import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    const url = new URL(window.location.href);
    url.searchParams.set('locale', lng);
    window.location.href = url.toString();
  };

  return (
    <div className="flex gap-2 text-sm font-bold">
      {i18n.language === 'ja' ? (
        <>
          <button onClick={() => changeLanguage('en')} className="text-gray-400 hover:text-white transition-colors">
            English
          </button>
          <span className="text-gray-600">|</span>
          <span className="text-white">日本語</span>
        </>
      ) : (
        <>
          <span className="text-white">English</span>
          <span className="text-gray-600">|</span>
          <button onClick={() => changeLanguage('ja')} className="text-gray-400 hover:text-white transition-colors">
            日本語
          </button>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;
